class LangModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};
        this.ui.$langSwitcher = document.querySelectorAll('.js-lang-switcher select');
    }

    bindEvents() {
        [].forEach.call(this.ui.$langSwitcher, item => {
            item.addEventListener('change', event => {
                window.location.href = event.target.value;
            });
        });
    }
}

export default LangModule;
